import React, { useEffect, useRef, useState } from 'react';
import { connect } from 'react-redux';
import params from 'configs/params';
import { filter } from 'lodash';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import { selector } from 'apps/services';
import { attemptSetLanguage } from 'apps/modules/app/AppActions';
import { withTranslation } from 'react-i18next';
import { EVChargingQuickshop, StandardShopQuickshop, Footer, PaymentStatus, LinkQuickshop } from 'components/core';
import { Modal, ModalBody, ModalFooter, ModalHeader, Button, FormGroup, Input } from 'reactstrap';
import { ENGLISH_LANG, REQUIRED, QUICKSHOP_PUBLIC_USE, QUICKSHOP_PRIVATE_USE, QUICKSHOP_RENTAL_PUBLIC_USE, QUICKSHOP_RENTAL_PRIVATE_USE, STATUS_CODE_CHARGING, STATUS_WAITING_FOR_PAYMENT, SWISH_STATUS_SUCCESS, PSP_TYPE_SWISH, SWISH_PAYMENT_SUCCESS_MSG, SWISH_PAYMENT_FAILED_MSG, SWISH_STATUS_PENDING, SWISH_TIMEOUT_MSG, QUICKSHOP_ROUTE, QUICKSHOP_RENTAL_ROUTE, LANGUAGES, EV_CHARGING_CONST, STANDARD_SHOP_CONST, TOAST_AUTO_CLOSE, TOAST_POSITION } from 'configs/constants';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { attemptEndRental, attemptOnlyStartPOSSession, attemptResetNotificationState, attemptLinkQuickshop, attemptPayPOSSession, attemptGetQuickshop, attemptCheckSwishPaymentStatus, attemptAddProductToCart, attemptStartPOSSession, attemptStopPOSSession } from 'apps/modules/quickshopweb/QuickshopWebActions';
import { useParams } from 'react-router-dom';
import { useIdle } from 'hooks';
import { getText } from 'helpers/app/getText';
import { produce, setAutoFreeze } from 'immer';

function Main({ app, attemptEndRental, attemptResetNotificationState, attemptOnlyStartPOSSession, attemptLinkQuickshop, attemptCheckSwishPaymentStatus, quickshopweb, attemptSetLanguage, attemptGetQuickshop, attemptAddProductToCart, attemptStartPOSSession, attemptStopPOSSession, attemptPayPOSSession }) {
  setAutoFreeze(false);
  const { quickshopid } = useParams();

  const [isQuickshopLinked, setIsQuickshopLinked] = useState(true);
  const [openEndRentalConfirmModal, setOpenEndRentalConfirmModal] = useState(false);
  const [timeLeft, setTimeLeft] = useState(null);
  const [state, setState] = useState({
    userID: '',
    userSessionID: '',
    openSwishPaymentModal: false,
    isPaymentInProgress: false,
    hasPaymentProcessed: false,
    selectedPaymentType: '',
    swishInterval: {},
    endRentalCustomerID: '',
    endRentalParams: {
      componentID: '',
      merchantID: '',
      customerID: '',
    },
  });
  const [errors, setErrors] = useState({
    endRentalCustomerID: '',
  });
  const timer = useRef(null);

  useEffect(() => {
    if (quickshopweb.get('quickshopWeb')?.statusCode !== STATUS_CODE_CHARGING && quickshopweb.get('quickshopWeb')?.isAutopilotEnabled === true && !timer?.current) {
      setTimeLeft(5);
      timer.current = setInterval(() => {
        onFetchQuickshop();
      }, 5000);
    } else if ((quickshopweb.get('quickshopWeb')?.statusCode === STATUS_CODE_CHARGING || quickshopweb.get('quickshopWeb')?.isAutopilotEnabled === false) && timer?.current) {
      setTimeLeft(null);
      clearInterval(timer.current);
    }
  }, [quickshopweb?.get('quickshopWeb')?.statusCode, quickshopweb?.get('quickshopWeb')?.isAutopilotEnabled]);

  useEffect(() => {
    if (timeLeft) {
      const interval = setInterval(() => {
        setTimeLeft((t) => t - 1);
      }, 1000);

      return () => clearInterval(interval);
    }
  }, [timeLeft]);

  const onFetchQuickshop = () => {
    setTimeLeft(5);
    attemptGetQuickshop(quickshopid);
  };

  const refreshPage = () => {
    location.reload();
  };

  useIdle({ onIdle: refreshPage, idleTime: 60 });

  useEffect(() => {
    attemptGetQuickshop(quickshopid);
    const queryParams = new URLSearchParams(window.location.search);
    const redirect_status = queryParams.get('redirect_status');
    if (redirect_status === 'succeeded') {
      setState({
        ...state,
        hasPaymentProcessed: true,
      });
    }
    if (!localStorage.getItem('secret')) {
      setState({
        ...state,
        hasPaymentProcessed: false,
      });
    }
    const clientSecret = new URLSearchParams(window.location.search).get('payment_intent_client_secret');
    if (!clientSecret) {
      localStorage.removeItem('secret');
      localStorage.removeItem('stripeAccountID');
    }

    const language = app.get('language');
    if (language !== navigator.userLanguage || navigator.language) {
      const browserLanguage = navigator.userLanguage || navigator.language;
      let languageCode = ENGLISH_LANG;
      if (browserLanguage?.length > 0 && filter(LANGUAGES, { code: browserLanguage.substring(0, browserLanguage.indexOf('-')) })?.length > 0) {
        languageCode = browserLanguage.substring(0, browserLanguage.indexOf('-'));
      }
      attemptSetLanguage(languageCode);
    }
  }, []);

  useEffect(() => {
    if (quickshopweb.get('swishPaymentStatus')?.length > 0 && quickshopweb.get('swishPaymentStatus') !== SWISH_STATUS_PENDING) {
      clearInterval(state.swishInterval);
      handleSwishPaymentModal();
      if (quickshopweb.get('swishPaymentStatus') && quickshopweb.get('swishPaymentStatus').toLowerCase() === SWISH_STATUS_SUCCESS) {
        toast.success(getText('notifications:SWISH_PAYMENT_SUCCESS_MSG'));
      } else {
        toast.error(getText('notifications:SWISH_PAYMENT_FAILED_MSG'));
      }
      startInterval();
    }
  }, [quickshopweb.get('swishPaymentStatus')]);

  useEffect(() => {
    if (quickshopweb.get('isQuickshopLinked') === true) {
      toast.success(getText('notifications:QUICKSHOP_LINKED_SUCCESS_MSG'));
      attemptResetNotificationState('isQuickshopLinked');
      setTimeout(() => window.location.reload(), 3000);
    }
  }, [quickshopweb.get('isQuickshopLinked')]);

  useEffect(() => {
    if (quickshopweb.get('isQuickshopLinkFailed') === true) {
      toast.error(getText('notifications:QUICKSHOP_LINK_FAILED_MSG'));
      attemptResetNotificationState('isQuickshopLinkFailed');
    }
  }, [quickshopweb.get('isQuickshopLinkFailed')]);

  useEffect(() => {
    if (quickshopweb.get('isQuickshopRentalEnded') === true) {
      attemptResetNotificationState('isQuickshopRentalEnded');
      window.location.reload(false);
    }
  }, [quickshopweb.get('isQuickshopRentalEnded')]);

  useEffect(() => {
    if (state.hasPaymentProcessed === true) {
      startInterval();
    }
  }, [state.hasPaymentProcessed]);

  const [counter, setCounter] = useState(5);
  const [intervalID, setIntervalID] = useState(-1);
  const startInterval = () => {
    setIntervalID(
      setInterval(() => {
        setCounter((prev) => (prev - 1) % 10);
      }, 1000),
    );
  };
  const stopInterval = () => {
    clearInterval(intervalID);
    setIntervalID(-1);
    setCounter(5);
  };
  useEffect(
    () => () => {
      clearTimeout(intervalID);
    },
    [],
  );

  useEffect(() => {
    if (counter === 0) {
      stopInterval();
      localStorage.removeItem('secret');
      localStorage.removeItem('stripeAccountID');
      window.location.href = QUICKSHOP_ROUTE(quickshopid);
    }
  }, [counter]);

  useEffect(() => {
    if (quickshopweb.get('error')?.description?.length > 0) {
      const error = quickshopweb.get('error');
      if (error?.code === 404) {
        setIsQuickshopLinked(false);
      } else if (error?.code === 409) {
        toast.dismiss();
        toast.error(getText('notifications:POS_SESSION_ALREADY_EXISTS_MSG'), { autoClose: 3000 });
      }
    }
  }, [quickshopweb.get('error')]);

  useEffect(() => {
    if (quickshopweb.get('isPayPOSSessionSucceed') && quickshopweb.get('swishPaymentStatus').length === 0 && state.selectedPaymentType === PSP_TYPE_SWISH) {
      const interval = setInterval(() => {
        attemptCheckSwishPaymentStatus(quickshopweb.get('posSessionID'));
      }, 5000);
      setState({
        ...state,
        swishInterval: interval,
      });
      setTimeout(() => {
        clearInterval(interval);
        handleSwishPaymentModal();
        toast.error(SWISH_TIMEOUT_MSG);
      }, 60000);
    }
  }, [quickshopweb.get('isPayPOSSessionSucceed'), quickshopweb.get('swishPaymentStatus')]);

  useEffect(() => {
    if (quickshopweb.get('isPOSSessionStopped') === true) {
      toast.dismiss();
      toast.success(getText('notifications:POS_SESSION_STOPPED_SUCCESSFULLY'), { autoClose: 3000 });
    }
  }, [quickshopweb.get('isPOSSessionStopped')]);

  useEffect(() => {
    if (quickshopweb.get('isPOSSessionStarted') === true) {
      setState({
        ...state,
        isPaymentInProgress: true,
      });
      const quickshopObj = quickshopweb.get('quickshopWeb');
      if (quickshopObj.statusCode === STATUS_CODE_CHARGING && quickshopObj.paymentStatusCode === STATUS_WAITING_FOR_PAYMENT) {
        attemptOnlyStartPOSSession();
      }
    }
  }, [quickshopweb.get('isPOSSessionStarted')]);

  useEffect(() => {
    if (quickshopweb.get('quickshopWeb')?._id) {
      const quickshopObj = quickshopweb.get('quickshopWeb');
      document.title = quickshopObj.quickShopName;
    }
  }, [JSON.stringify(quickshopweb.get('quickshopWeb'))]);

  const addProductToCart = (data) => {
    attemptAddProductToCart(data);
    setState({
      ...state,
      userID: data.userId,
    });
  };

  const handleSwishPaymentModal = () => {
    setState({
      ...state,
      openSwishPaymentModal: !state.openSwishPaymentModal,
    });
    if (state.openSwishPaymentModal) {
      clearInterval(state.swishInterval);
    }
  };

  const onStartCharging = (id) => {
    const quickshopWeb = quickshopweb.get('quickshopWeb');
    attemptStartPOSSession({
      quickshopID: id,
      userSessionID: quickshopWeb.evCharging.pointOfServiceID,
    });
  };

  const onStopCharging = (id) => {
    attemptStopPOSSession({
      quickshopID: id,
    });
  };

  const onPayPOSSession = (params) => {
    if (!params.posSessionID || params?.posSessionID?.length === 0) {
      params.posSessionID = quickshopweb.get('posSessionID');
    }
    attemptPayPOSSession(params);
    if (params.payMobilePhone) {
      window.location = 'swish://';
      setState({
        ...state,
        selectedPaymentType: PSP_TYPE_SWISH,
        openSwishPaymentModal: true,
      });
    }
  };

  const onLanguageChange = (opt) => {
    const lang = filter(LANGUAGES, { value: opt?.value })?.[0]?.code || LANGUAGES[0].code;
    attemptSetLanguage(lang);
  };

  const setIsPaymentCanceled = () => {
    setState({
      ...state,
      isPaymentInProgress: false,
    });
  };

  const onLinkQuickshop = (code) => {
    attemptLinkQuickshop({
      quickshopID: quickshopid,
      quickshopCode: code,
    });
  };

  const onPayAlreadyStartedPOSSession = (id) => {
    const quickshopWeb = quickshopweb.get('quickshopWeb');
    attemptStartPOSSession({
      quickshopID: id,
      userSessionID: quickshopWeb.evCharging.pointOfServiceID,
    });
  };

  const onEndRental = () => {
    const quickshopWeb = quickshopweb.get('quickshopWeb');
    const params = {
      merchantID: quickshopWeb.merchantID,
      componentID: quickshopWeb.evCharging.componentID,
      customerID: quickshopWeb.rental.customerID,
    };
    setOpenEndRentalConfirmModal(true);
    setState(
      produce((draft) => {
        draft.endRentalParams = params;
      }),
    );
  };

  const onConfirmEndRental = () => {
    if (state.endRentalCustomerID?.length === 0) {
      setErrors(
        produce((draft) => {
          draft.endRentalCustomerID = REQUIRED('Customer ID', getText('notifications:FIELD_VALIDATION_REQUIRED_MSG'));
        }),
      );
    } else if (state.endRentalCustomerID?.length > 0 && state.endRentalCustomerID !== state.endRentalParams.customerID) {
      setErrors(
        produce((draft) => {
          draft.endRentalCustomerID = getText('main:INCORRECT_CUSTOMER_ID_MSG');
        }),
      );
    } else {
      setErrors(
        produce((draft) => {
          draft.endRentalCustomerID = '';
        }),
      );
      setOpenEndRentalConfirmModal(false);
      attemptEndRental(state.endRentalParams);
    }
  };

  const onEndRentalCustomerIDChange = (ev) => {
    const { value } = ev.target;

    setState(
      produce((draft) => {
        draft.endRentalCustomerID = value;
      }),
    );
  };

  const quickshopWeb = quickshopweb.get('quickshopWeb');
  const isLoadingQuickshop = quickshopweb.get('isLoading');
  const language = app.get('language');
  const pspClientSecret = localStorage.getItem('secret');
  const stripeAccountID = localStorage.getItem('stripeAccountID');
  let opts = {};
  if (stripeAccountID?.length > 0) {
    opts = { stripeAccount: stripeAccountID };
  }
  const stripePromise = loadStripe(params.stripePublicKey, opts);

  const options = {
    // passing the client secret obtained in step 2
    clientSecret: pspClientSecret,
    stripeAccountID,
    // Fully customizable with appearance API.
    appearance: {
      /*...*/
    },
  };

  let isQuickshopRentalSet = false;
  let isQuickshopNeedsRental = false;

  if (!quickshopWeb.usageMode || (quickshopWeb?.usageMode && quickshopWeb?.usageMode === QUICKSHOP_PUBLIC_USE) || quickshopWeb?.usageMode === QUICKSHOP_PRIVATE_USE) {
    isQuickshopRentalSet = false;
  } else if (quickshopWeb?.usageMode === QUICKSHOP_RENTAL_PUBLIC_USE || quickshopWeb?.usageMode === QUICKSHOP_RENTAL_PRIVATE_USE) {
    if (quickshopWeb.rental.customerID) {
      isQuickshopRentalSet = true;
    } else {
      isQuickshopNeedsRental = true;
    }
  }

  return [
    <ToastContainer key="1" autoClose={TOAST_AUTO_CLOSE} position={TOAST_POSITION} />,
    !isLoadingQuickshop && !state.hasPaymentProcessed && isQuickshopLinked && !quickshopWeb._id && (
      <div className="loading-container" key="2">
        <p>{getText('main:QUICKSHOP_NOT_FOUND_MSG')}</p>
      </div>
    ),
    !state.hasPaymentProcessed && ((isQuickshopRentalSet && !isQuickshopNeedsRental) || (!isQuickshopRentalSet && !isQuickshopNeedsRental)) && quickshopWeb?.quickShopTemplate === EV_CHARGING_CONST && isQuickshopLinked && (
      <EVChargingQuickshop key="3" timeLeft={timeLeft} language={language} quickshop={quickshopWeb} isQuickshopRentalSet={isQuickshopRentalSet} onPayAlreadyStartedPOSSession={onPayAlreadyStartedPOSSession} pspClientSecret={pspClientSecret} stripeAccountID={stripeAccountID} isPaymentInProgress={state.isPaymentInProgress} setIsPaymentCanceled={() => setIsPaymentCanceled()} payPOSSession={(params) => onPayPOSSession(params)} onStartCharging={(id) => onStartCharging(id)} onStopCharging={(id) => onStopCharging(id)} />
    ),
    isLoadingQuickshop && (
      <div className="loading-container" key="4">
        <b className="blink">{getText('main:LOADING_TEXT_MSG')}</b>
      </div>
    ),
    !state.hasPaymentProcessed && ((isQuickshopRentalSet && !isQuickshopNeedsRental) || (!isQuickshopRentalSet && !isQuickshopNeedsRental)) && quickshopWeb?.quickShopTemplate === STANDARD_SHOP_CONST && isQuickshopLinked && <StandardShopQuickshop key="5" quickshop={quickshopWeb} isQuickshopRentalSet={isQuickshopRentalSet} payPOSSession={(data) => onPayPOSSession(data)} addProductToCart={(data) => addProductToCart(data)} />,
    !state.hasPaymentProcessed && !isQuickshopRentalSet && isQuickshopNeedsRental && isQuickshopLinked && (
      <div className="my-3 p-3 text-center" key="6">
        <p>{getText('main:RENT_NOW_TEXT1')}</p>
        {quickshopWeb.rentalPriceInformation?.length > 0 && (
          <div>
            <p>
              <b>{getText('main:PRICE')}:</b>
            </p>
            <p>
              <b>{quickshopWeb.rentalPriceInformation}</b>
            </p>
          </div>
        )}
        <p>{getText('main:RENT_NOW_TEXT2')}</p>
        <button
          type="button"
          onClick={() => {
            window.location.href = QUICKSHOP_RENTAL_ROUTE(quickshopWeb._id);
          }}
          className="btn btn-success"
        >
          {getText('main:RENT_NOW')}
        </button>
      </div>
    ),
    !isQuickshopLinked && <LinkQuickshop key="7" onLinkQuickshop={(code) => onLinkQuickshop(code)} />,
    state.hasPaymentProcessed && pspClientSecret?.length > 0 && (
      <div className="my-3 p-3 text-center" key="8">
        <div className="header-div text-center d-inline-block">
          <a
            className="table-pointer"
            onClick={() => {
              localStorage.removeItem('secret');
              localStorage.removeItem('stripeAccountID');
              window.location.href = QUICKSHOP_ROUTE(quickshopWeb._id);
            }}
          >
            <img src={quickshopWeb.imageURL || ''} className="header-img mb-10" />
          </a>
          <Elements stripe={stripePromise} options={options}>
            <PaymentStatus />
          </Elements>
          <button
            type="button"
            onClick={() => {
              localStorage.removeItem('secret');
              localStorage.removeItem('stripeAccountID');
              window.location.href = QUICKSHOP_ROUTE(quickshopWeb._id);
            }}
            className="btn back-to-dashboard-btn btn-primary"
          >
            {`${getText('main:BACK_TO_QUICKSHOP')} ${counter} secs`}
          </button>
        </div>
      </div>
    ),
    <Footer key="9" moreInfoURL={quickshopWeb?.moreInfoURL} onEndRental={onEndRental} isQuickshopRentalSet={isQuickshopRentalSet} privacyPolicyURL={quickshopWeb?.privacyPolicyURL} customerAgreementURL={quickshopWeb?.customerAgreementURL} pageLanguages={LANGUAGES} onLanguageChange={(opt) => onLanguageChange(opt)} defaultLanguage={language?.length > 0 && filter(LANGUAGES, { code: language })?.length > 0 ? filter(LANGUAGES, { code: language })[0]?.value : LANGUAGES[0].value} />,
    <Modal key="10" isOpen={state.openSwishPaymentModal} toggle={() => handleSwishPaymentModal()}>
      <ModalBody>
        <div>
          <p>{getText('main:SWISH_MODAL_MSG1')}</p>
          <p>{getText('main:SWISH_MODAL_MSG2')}</p>
          <p>{getText('main:SWISH_MODAL_MSG3')}</p>
        </div>
      </ModalBody>
    </Modal>,
    <Modal key="11" isOpen={openEndRentalConfirmModal} toggle={() => setOpenEndRentalConfirmModal(!openEndRentalConfirmModal)}>
      <ModalHeader toggle={() => setOpenEndRentalConfirmModal(!openEndRentalConfirmModal)}>{getText('main:END_RENTAL')}</ModalHeader>
      <ModalBody>
        <p>{getText('main:END_RENTAL_CONFIRM_TEXT_MSG')}</p>
        <FormGroup className="text-left">
          <label>{getText('main:CUSTOMER_ID')}:</label>
          <Input className={`${errors.endRentalCustomerID && `input-normal-error-msg`}`} maxLength={100} type="text" name="endRentalCustomerID" value={state.endRentalCustomerID || ''} onChange={(val) => onEndRentalCustomerIDChange(val)} />
          <p className={`error-msg ${!errors.endRentalCustomerID && 'hidden'}`}>{errors.endRentalCustomerID}</p>
        </FormGroup>
      </ModalBody>
      <ModalFooter>
        <Button color="primary" onClick={() => onConfirmEndRental()}>
          {getText('main:YES')}
        </Button>{' '}
        <Button color="secondary" onClick={() => setOpenEndRentalConfirmModal(false)}>
          {getText('main:NO')}
        </Button>
      </ModalFooter>
    </Modal>,
  ];
}

const mapStateToProps = (state) => selector(state, false, ['authorisation', 'app', 'quickshopweb']);

const mapDispatchToProps = (dispatch) => {
  return {
    attemptEndRental: (data) => dispatch(attemptEndRental(data)),
    attemptStartPOSSession: (data) => dispatch(attemptStartPOSSession(data)),
    attemptStopPOSSession: (data) => dispatch(attemptStopPOSSession(data)),
    attemptGetQuickshop: (data) => dispatch(attemptGetQuickshop(data)),
    attemptAddProductToCart: (data) => dispatch(attemptAddProductToCart(data)),
    attemptPayPOSSession: (data) => dispatch(attemptPayPOSSession(data)),
    attemptSetLanguage: (data) => dispatch(attemptSetLanguage(data)),
    attemptLinkQuickshop: (data) => dispatch(attemptLinkQuickshop(data)),
    attemptOnlyStartPOSSession: (data) => dispatch(attemptOnlyStartPOSSession(data)),
    attemptCheckSwishPaymentStatus: (data) => dispatch(attemptCheckSwishPaymentStatus(data)),
    attemptResetNotificationState: (data) => dispatch(attemptResetNotificationState(data)),
  };
};

export default withTranslation('main')(connect(mapStateToProps, mapDispatchToProps)(Main));
